export default class FormHelper {
    static initRuntimeProperties(controls: any[], parentControl: any = null) {
        // Init runtime properties
        for (let control of controls) {
            control.fullName = parentControl ? parentControl.fullName + "." + control.name : control.name;
            control.dataSourceParameters = [];
            control.isEditing = false;
            control.validationErrors = [];
            control.additionalValues = [];
            control.isValueChangedOutside = false;
        }
    }

    public static getValidationErrors(validationState: any): any[] {
        return Object.entries(validationState).flatMap(
            ([name, messages]) => (messages as string[]).map(message => ({ name, message }))
        );
    }

    public static isControlValidationError(controlName: string, validationErrors: any[]): boolean {
        return validationErrors.some(x => x.name === controlName);
    }

    public static getRequestVerificationToken(): string {
        return (document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement)?.value;
    }

    public static showPassword(inputId: string) {
        const input = document.getElementById(inputId);
        if (!input) return;
        input.setAttribute("type", input.getAttribute("type") === "password" ? "text" : "password");
    }

    static setFocus(contextElement: HTMLElement) {
        // Set focus on first input element
        let firstInput: HTMLElement | null = contextElement.querySelector("input");
        if (firstInput) {
            firstInput.focus();
        }
    }

    static removeFocus() {
        // Remove document focus
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }
}